module.exports = __webpack_public_path__ + "static/img/m501.1b448310.gif";